import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { FiLogOut } from 'react-icons/fi';
import { Modal, Button } from "react-bootstrap";
import { Tooltip } from '@mui/material';

const Logout = () => {
  const { logout } = useAuth();
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleLogout = () => {
    setShowConfirmation(true);
  };

  const handleConfirmLogout = () => {
    logout();
    setShowConfirmation(false);
  };

  const handleCancelLogout = () => {
    setShowConfirmation(false);
  };
  //className="logout-button"
  return (
    <>
      <Tooltip title="LogOut">
        <button onClick={handleLogout}>
          <FiLogOut style={{ color: 'orangered', fontWeight: 'bolder' }} />
        </button>
      </Tooltip>

      <Modal show={showConfirmation} onHide={handleCancelLogout}>
        <Modal.Header closeButton>
          <Modal.Title>Logout Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelLogout}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmLogout}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Logout;
